module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['sky-reveal', {
      closed: !_vm.showContent
    }],
    attrs: {
      "aria-expanded": _vm.ariaExpanded
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-600a8262"}!./scripts/sky-reveal/SkyReveal.html
// module id = 369
// module chunks = 1